import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const TextareaControl = styled.textarea`
  flex: 1 0 auto;
  outline: none;
  border: none;
  background: transparent;
  font-family: ${({ theme }) => theme.fontset.opensans};
  font-size: 1rem;
  width: 70%;
  resize: none;
  height: 100%;
  padding-top: ${props =>
    props.variant === 'leadDetail' ? pxToRem('16px') : 0};
  :-webkit-autofill,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
`;

const getStyles = props => {
  let style;
  switch (props.variant) {
    case 'form':
      style = css`
        width: ${pxToRem('431px')};
        height: ${pxToRem('56px')};
        margin: ${pxToRem('10px')};
        // padding: 0 ${pxToRem('10px')} ${pxToRem('4px')} ${pxToRem('16px')};
        border: ${pxToRem('1px')} solid ${props.theme.colors.mainBlue};
        position: relative;
        height: ${pxToRem('152px')};
        background-color: ${props => props.theme.colors.white};
        
        ${props =>
          props.status === 'invalid' &&
          css`
            border: ${pxToRem('1px')} solid
              ${props.theme.colors.semantic.secondary};
          `}
        :hover {
          ${props =>
            props.status !== 'invalid' &&
            css`
              border: ${pxToRem('1px')} solid ${props.theme.colors.mainBlue};
            `}
        }
      `;
      break;
    case 'leadDetail':
      style = css`
        width: 100%;
        height: ${pxToRem('56px')};
        padding: 0 ${pxToRem('4px')};
        border: none;
        position: relative;
        height: ${pxToRem('152px')};
        background-color: transparent;
      `;
      break;
    default:
      break;
  }

  return style;
};

export const TextareaWrapper = styled.div`
  border-radius: ${pxToRem('6px')};
  padding: ${pxToRem('22px')} ${pxToRem('16px')} ${pxToRem('16px')}
    ${pxToRem('16px')};
  border: ${pxToRem('1px')} solid rgba(70, 122, 251, 0.4);
  ${props =>
    props.variant === 'editaccountdata' &&
    css`
      border: ${pxToRem('1px')} solid rgba(70, 122, 251, 1);
      position: relative;
    `}
  ${props =>
    props.status === 'invalid' &&
    css`
      border: ${pxToRem('1px')} solid ${props.theme.colors.redError};
    `}
  display: flex;
  align-items: center;
  opacity: 1;
  ${props => getStyles(props)};

  ${props =>
    !props.value &&
    css`
      opacity: 0.4;
    `}
`;

export const InvalidLabel = styled.div`
  color: red;
  font-size: 1rem;
  font-family: inherit;
`;

export const Placeholder = styled.label`
  position: absolute;
  font-family: 'OpenSans';
  font-size: ${pxToRem('11px')};
  color: ${props =>
    props.status === 'invalid'
      ? props.theme.colors.semantic.secondary
      : props.theme.colors.mainBlue};
  background-color: white;
  padding: 0 ${pxToRem('5px')};
  opacity: 0;
  z-index: -1;
  ${props =>
    props.hasValue &&
    css`
      transform: translateX(${pxToRem('4.5px')}) translateY(${pxToRem('-76px')});
      opacity: 1;
      z-index: 5;
      transition: all 250ms;
      font-weight: 600;
    `};
`;

export const Counter = styled.div`
  font-family: 'OpenSans';
  position: absolute;
  right: ${pxToRem('8px')};
  top: ${pxToRem('4px')};
  font-size: ${pxToRem('12px')}
    ${props =>
      props.status === 'invalid' &&
      css`
        color: ${props.theme.colors.semantic.secondary};
      `};
`;
